import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { AdminReviewRequest, UserFeedbackRequest } from '@frontend/types';

import { getFeedback, submitAdminReview, submitUserFeedback } from '../services/specialized-agent';

export function useGetFeedback(instanceId: string, memoryId: string, enabled = true) {
  return useQuery({
    queryKey: getFeedback.key(instanceId, memoryId),
    queryFn: getFeedback(instanceId, memoryId),
    enabled: enabled && !!instanceId && !!memoryId,
  });
}

export function useSubmitFeedback(instanceId: string, memoryId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ turn, data }: { turn: number; data: UserFeedbackRequest }) =>
      submitUserFeedback(instanceId, memoryId, turn, data)(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getFeedback.key(instanceId, memoryId),
      });
    },
  });
}

export function useSubmitAdminReview(instanceId: string, memoryId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: AdminReviewRequest) => submitAdminReview(instanceId, memoryId, data)(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getFeedback.key(instanceId, memoryId),
      });
    },
  });
}
